import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Checkbox } from "@mui/material";

import { withLocalizer } from "utilities/withLocalizer";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ConcessionEditor from "./concessionEditor";
import ItineraryInfo from "../common/itineraryInfo";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import { CONFIGURATION } from "utilities/configuration";

import { Icon } from "__ICON_REFERENCE__";
import ErrorAlert from "../common/errorAlert";

import "../../customize.scss";

export class CustomizeQuoteStepThree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        };
    }

    onBarClick = (itinerary) =>{
        let { customQuote } = this.props;
        let { itineraryNumber } = itinerary;
        // Update the store with new data object
        this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map(itinerary => ({
                        ...itinerary, isConcessionExpanded: (itinerary.itineraryNumber === itineraryNumber ? !itinerary.isConcessionExpanded : false )
                    }))
                }))
            }))
        }));
        
    };

    handleAll = (hasSelected) => {
        this.updateConcessionSelection(null, null, !hasSelected);
    };

    handleConcessionSelectorChange = (itinerary, concession) => {
        this.updateConcessionSelection(itinerary, concession, null);
    };

    updateConcessionSelection = (itinerary, concession, allSelected = null) => {
        let { customQuote } = this.props;
        let { itineraryNumber } = itinerary || {};

        // Update the store with new data object
        this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map(itinerary => {

                        if((allSelected !== null && !itinerary.hideRoomConcession) || (itinerary && itinerary.itineraryNumber === itineraryNumber)) {
                            return {
                                ...itinerary,
                                itineraryDetail: {
                                    ...itinerary.itineraryDetail,
                                    roomType: {
                                        ...itinerary.itineraryDetail.roomType,
                                        customConcessions:
                                        itinerary.itineraryDetail.roomType?.customConcessions?.map(
                                            (customConcession) => {
                                                if (
                                                    (allSelected !== null) || (customConcession.concessionIndex === concession.concessionIndex)
                                                ) {
                                                    const included = (allSelected !== null) ? (allSelected) : !customConcession.included;
                                                    return {
                                                        ...customConcession,
                                                        included,
                                                        concessionDisplayText: !included
                                                            ? customConcession.originalText
                                                            : customConcession.concessionDisplayText
                                                    };
                                                }
                                                return customConcession;
                                            }
                                        )
                                    }
                                }
                            };
                        }
                        else {
                            return itinerary;
                        }
                    })
                }))
            }))
        }));
    };

    handleConcessionUpdate = (itinerary, concession, index, tag, value, tagIndex) => {
        let { customQuote } = this.props;
        let { itineraryNumber } = itinerary;

        // Update the store with new data object
        this.props.dispatch(
            updateCustomQuote({
                ...customQuote.data,
                quoteOptions: customQuote?.data?.quoteOptions?.map((quoteOption) => ({
                    ...quoteOption,
                    products: quoteOption.products.map((product) => ({
                        ...product,
                        itineraries: product.itineraries?.map((itinerary) => {
                            if (itinerary && !itinerary.hideRoomConcession && itinerary.itineraryNumber === itineraryNumber) {
                                return {
                                    ...itinerary,
                                    itineraryDetail: {
                                        ...itinerary.itineraryDetail,
                                        roomType: {
                                            ...itinerary.itineraryDetail.roomType,
                                            customConcessions:
                                            itinerary.itineraryDetail.roomType.customConcessions?.map(
                                                (customConcession) => {
                                                    if (
                                                        customConcession.concessionIndex === concession.concessionIndex
                                                    ) {
                                                        return {
                                                            ...customConcession,
                                                            placeHolderObjects:
                                                            customConcession.placeHolderObjects?.map(
                                                                (obj, idx) => {
                                                                    if (idx === tagIndex && obj?.data) {
                                                                        return {
                                                                            ...obj,
                                                                            data: {
                                                                                ...obj.data,
                                                                                value
                                                                            }
                                                                        };
                                                                    }
                                                                    return obj;
                                                                }
                                                            )
                                                        };
                                                    }
                                                    return customConcession;
                                                }
                                            )
                                        }
                                    }
                                };
                            } else {
                                return itinerary;
                            }
                        })
                    }))
                }))
            })
        );
    };

    hasSelectedConcession = (quoteOptions) => {
        let hasConcession = false;
        for(const quoteOption of quoteOptions || []) {
            for(const product of quoteOption.products || [])  {
                for(const itinerary of product.itineraries || []) {
                    if(itinerary && !itinerary.hideRoomConcession && itinerary.included) {
                        const customConcessions = itinerary?.itineraryDetail?.roomType?.customConcessions || [];
                        if(customConcessions.length > 0) {
                            hasConcession = true;
                        }
                        for(const customConcession of customConcessions) {
                            if(customConcession.included) {
                                return true;
                            }
                        }    
                    }
                }
            }
        }
        if(!hasConcession) return true;
        return false;
    };


    hasConcessionAvailable = (quoteOptions) => {
        for(const quoteOption of quoteOptions || []) {
            for(const product of quoteOption.products || [])  {
                for(const itinerary of product.itineraries || []) {
                    if(itinerary && !itinerary.hideRoomConcession && itinerary.included) {
                        const customConcessions = itinerary?.itineraryDetail?.roomType?.customConcessions || [];
                        if(customConcessions.length > 0) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    };

    render() {
        const { data, customQuote, events, error } = this.props;
        const { currentStep } = data;
        if (currentStep !== 3) {
            return null;
        }
         
        const isOutlineIcon = CONFIGURATION.CHECK_CIRCLE_ROUNDED_ICON_IS_OUTLINED;

        let { quoteOptions } = customQuote?.data || [];

        const hasConcessionAvailable = this.hasConcessionAvailable(quoteOptions);

        let hasSelected = false;
        if(hasConcessionAvailable) {
            hasSelected = this.hasSelectedConcession(quoteOptions);
        }

        return (
            <>
                {customQuote ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-3-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-3-intro") }
                            </div>
                        </div>
                        {
                            hasConcessionAvailable && 
                            <div className="text-right-align margin-top-2x margin-bottom top-command">
                                <Button
                                    className="link-button"
                                    data-testid={"deselectAllBtn"}
                                    onClick={() => this.handleAll(hasSelected)}
                                >
                                    {hasSelected ? this.props.localize("qma-deselect-all") : this.props.localize("qma-select-all") }
                                </Button>
                            </div>
                        }
                        
                        <div className="custom-quote-editor-container">
                            {customQuote?.data?.quoteOptions?.map((option, optionIndex) => 
                                option?.products?.map((product, productIndex) => 
                                    product?.itineraries?.map((itinerary, itineraryIndex) => 
                                        itinerary.included ?
                                            <div key={itineraryIndex} className="custom-quote-editor-panel-wrapper with-border"> 
                                                <div className="custom-quote-editor-panel with-panel-bar">
                                                    <div className="d-flex">
                                                        <div 
                                                            className={"col-concession-itinerary-bar-left" + (!itinerary.isConcessionExpanded ? " area-clickable" : "")}
                                                            onClick={() => { if(!itinerary.isConcessionExpanded) this.onBarClick(itinerary);}}
                                                        >
                                                            <strong>{itinerary.itineraryNumber}.</strong>
                                                        </div>
                                                        <div className="col-concession-itinerary-bar-right">
                                                            <div className="d-flex custom-quote-editor-panel-bar">
                                                                <div 
                                                                    className={"bar-info" + (!itinerary.isConcessionExpanded ? " area-clickable" : "")}
                                                                    onClick={() => { if(!itinerary.isConcessionExpanded) this.onBarClick(itinerary);}}
                                                                >
                                                                    <ItineraryInfo option={option} itinerary={itinerary} product={product} />
                                                                </div>
                                                                <div className="buttons">
                                                                    <div className="d-flex">
                                                                        { itinerary?.itineraryDetail?.roomType?.customConcessions?.length > 0 ?
                                                                            (itinerary?.itineraryDetail?.roomType?.customConcessions?.filter(c => c.included).length > 0 ?
                                                                                <>
                                                                                    <div>
                                                                                        {isOutlineIcon ? <CheckCircleOutlineRoundedIcon className="selected-icon" /> : <CheckCircleRoundedIcon className="selected-icon" />}
                                                                                    </div>
                                                                                    <div className="selected-icon-label">
                                                                                        { this.props.localize("qma-applied") }
                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                <div>
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        className={"btn-mariner-white " + (itinerary.isConcessionExpanded ? " area-non-clickable" : "")}
                                                                                        data-testid={"emailBtn"}
                                                                                        onClick={() => { if(!itinerary.isConcessionExpanded) this.onBarClick(itinerary);}}
                                                                                    >
                                                                                        <Icon
                                                                                            name="edit--n"
                                                                                            className="icon-12 margin-right wvi-icon-16"
                                                                                        />
                                                                                        <span className="is-mobile">{this.props.localize("qma-edit")} </span>
                                                                                    </Button>
                                                                                </div>) : null
                                                                        }
                                                                        <div onClick={() => this.onBarClick(itinerary)} className="area-clickable">
                                                                            <Icon
                                                                                name={ itinerary.isConcessionExpanded ? "arrow-up" : "arrow-down"}
                                                                                className="icon-2x"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                    <div className={
                                                        itinerary.isConcessionExpanded
                                                            ? "show d-flex margin-top-1x margin-bottom-1x"
                                                            : "hide"
                                                    }>
                                                        <div className="col-concession-itinerary-left">
                                                            
                                                        </div>
                                                        <div className="col-concession-itinerary-right">
                                                            {
                                                                (!itinerary?.hideRoomConcession) && itinerary?.itineraryDetail?.roomType?.customConcessions && itinerary?.itineraryDetail?.roomType?.customConcessions.length > 0 ?
                                                                    itinerary?.itineraryDetail?.roomType?.customConcessions.map((concession, concessionIndex) => (
                                                                        <div key={itinerary.itineraryNumber + "-" + concessionIndex} className="concession-panel-wrapper">
                                                                            <div className="d-flex ">
                                                                                <div className="col-concession-selector">
                                                                                    <Checkbox
                                                                                        checked={concession.included}
                                                                                        onChange={ () => this.handleConcessionSelectorChange(itinerary, concession) }
                                                                                        inputProps={{ "aria-label": "controlled" }}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-concession-panel panel-heading">
                                                                                    <strong>{ this.props.localize("qma-include") }</strong>
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-flex ">
                                                                                <div className="col-concession-selector">
                                                                                </div>
                                                                                <div className="col-concession-panel">
                                                                                    <ConcessionEditor data={{ languageCode: customQuote?.data?.languageCode, concession, itinerary }} events={{ handleUpdate: this.handleConcessionUpdate }} />
                                                                                </div>
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    ))
                                                                    :
                                                                    <div key={itinerary.itineraryNumber + "-" + crypto.randomUUID()} className="concession-panel-wrapper">
                                                                        {this.props.localize("qma-custom-quote-step-3-no-concessions")}
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
            
                                                </div>
                                            </div>
                                            : null
                                    )
                                )
                            )}
                        </div>
                    </div>
                    :null
                }
                {error && error.trim().length > 0 ?
                    <ErrorAlert 
                        error={error} 
                        isShowAlert={(error && error.trim().length > 0)} 
                        closeAlert={() => this.props.events && this.props.events.onAlertClose && this.props.events.onAlertClose()} 
                    />
                    : null
                }
            </>
        );
    }
}    

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteStepThree));
